import formMainHubThirdPartyAuthProviderSetup from './formMainHubThirdPartyAuthProviderSetup';
import formAppThirdPartyAuthProviderAppearance from './formAppThirdPartyAuthProviderAppearance';
import formAppThirdPartyAuthProviderUserCodeView from './formAppThirdPartyAuthProviderUserCodeView';
import formAppThirdPartyAuthProviderUserManagement from './formAppThirdPartyAuthProviderUserManagement';
export default {
  title: 'Blocking Provider',
  attributeName:'thirdPartyAuthProvider',
  createURL: '',
  sessionParams: [],
  getURL: 'mainHubs/mainHubId/thirdPartyProviders',
  updateURL: 'mainHubs/mainHubId/thirdPartyProviders',
  sessionParams: ['mainHubId'],
  idAttribute: 'id',
  noArea: true,
  goBack: false,
  idUpdate:true,
  noUpdateWithId: false,
  autoUpdate: false,
  updateFormAfterSave: true,
  formConfig: [
    formMainHubThirdPartyAuthProviderSetup,
    formAppThirdPartyAuthProviderAppearance,
    formAppThirdPartyAuthProviderUserManagement,
    formAppThirdPartyAuthProviderUserCodeView
  ],
};
